import TaskAssignList from './TaskAssignList';
import TaskAssignCreate from './TaskAssignCreate';
import TaskAssignEdit from './TaskAssignEdit';

export default {
    list: TaskAssignList,
    edit: TaskAssignEdit,
    create: TaskAssignCreate,
}